import {
  Dice5,
  Dumbbell,
  Feather,
  Gamepad2,
  Mountain,
  Snowflake,
  Swords,
  User,
  Waves,
} from 'lucide-react'
import { cn } from '../../lib/utils'

// Icons that also appear in the app's own UI (Trophy/Crown/Flame/Zap/Star/
// Target/Medal/Award) are deliberately excluded so users can't pick an avatar
// that collides with in-app iconography.
export const AVATAR_ICON_LIBRARY = {
  dumbbell: Dumbbell,
  gamepad: Gamepad2,
  dice: Dice5,
  snowflake: Snowflake,
  waves: Waves,
  feather: Feather,
  swords: Swords,
  mountain: Mountain,
}

const SIZE_CLASSES = {
  xs: 'h-6 w-6 text-xs',
  sm: 'h-8 w-8 text-sm',
  md: 'h-10 w-10 text-base',
  lg: 'h-16 w-16 text-2xl',
  xl: 'h-24 w-24 text-4xl',
}

const ICON_SIZE = {
  xs: 'h-3 w-3',
  sm: 'h-4 w-4',
  md: 'h-5 w-5',
  lg: 'h-8 w-8',
  xl: 'h-12 w-12',
}

export function Avatar({ fullName, avatarUrl, avatarType, size = 'md', className }) {
  const classes = cn(
    'shrink-0 rounded-full bg-primary/20 flex items-center justify-center font-bold overflow-hidden',
    SIZE_CLASSES[size] || SIZE_CLASSES.md,
    className,
  )

  const initial = (fullName || 'U').charAt(0).toUpperCase()

  if (avatarType === 'photo' && avatarUrl) {
    return (
      <div className={classes}>
        <img src={avatarUrl} alt={fullName || 'avatar'} className="h-full w-full object-cover" />
      </div>
    )
  }

  if (avatarType === 'google' && avatarUrl) {
    return (
      <div className={classes}>
        <img src={avatarUrl} alt={fullName || 'avatar'} className="h-full w-full object-cover" referrerPolicy="no-referrer" />
      </div>
    )
  }

  if (avatarType === 'icon' && avatarUrl && AVATAR_ICON_LIBRARY[avatarUrl]) {
    const Icon = AVATAR_ICON_LIBRARY[avatarUrl]
    return (
      <div className={classes}>
        <Icon className={cn(ICON_SIZE[size] || ICON_SIZE.md, 'text-primary')} />
      </div>
    )
  }

  if (!fullName) {
    return (
      <div className={classes}>
        <User className={cn(ICON_SIZE[size] || ICON_SIZE.md, 'text-muted-foreground')} />
      </div>
    )
  }

  return <div className={classes}>{initial}</div>
}
